import { useMemo } from "react";
import { useNonNullablePrevious } from "@ui/lib/hooks/usePrevious";
import type { DashboardBlockModelT } from "../../../../../../schema/dashboard";

export function usePreset(block: DashboardBlockModelT | null | undefined) {
  const inferredPreset = useMemo(() => {
    const marks = block?.kind === "PLOT" ? block?.config.layers.map(({ mark }) => mark) : undefined;

    const isScatterplot = marks && marks.length > 0 && marks?.every(mark => mark === "scatter");
    const isTimeseries = marks && marks.length > 0 && marks?.every(mark => mark === "line");

    return isScatterplot ? "scatter" : isTimeseries ? "line" : undefined;
  }, [block]);

  const previousInferredPreset = useNonNullablePrevious(inferredPreset);

  return useMemo(
    () =>
      block?.kind === "PLOT" && block?.config.layers.length === 0
        ? previousInferredPreset
        : inferredPreset,
    [block, inferredPreset, previousInferredPreset],
  );
}
